import * as actionTypes from './action-types';
import { ProductSelection } from 'components/ProductsSelection/types';

export type StateType = {
  readonly selection: ProductSelection;
};

export const initialState: StateType = {
  selection: {
    accounts: [],
    items: [],
    states: [],
    stores: [],
  },
};

const addLabelToItem = (item) => ({
  id: item,
  label: item,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_VALUES:
      const filters = action.payload;
      return {
        selection: {
          accounts: filters.accounts.map(addLabelToItem),
          states: filters.states.map(addLabelToItem),
          stores: filters.stores.map(addLabelToItem),
          items: filters.items.map(addLabelToItem),
        },
      };
    case actionTypes.CLEAR_SELECTIONS:
      return {
        ...state,
        selection: { ...initialState.selection },
      };
    case actionTypes.APPLY_VALUES:
      return {
        selection: {
          ...state.selection,
          [action.payload.currentMenu]: [...action.payload.values],
        },
      };
    default:
      return state;
  }
};

export default reducer;
